export default {
  frontpage: "/",
  chordProgressionDrill: "/chord-progression",
  contextual: "/contextual-ear-training",
  chordConstruction: "/chord-construction",
  fretboardNotes: "/guitar-fretboard-note-naming",
  fretboardInterval: "/guitar-fretboard-intervals",
  intervalTraining: "/interval-training",
  melodicDictation: "/melodic-dictation-ear-training",
  signIn: "/sign-in",
  profile: "/profile",
  contact: "/contact",
} as const;
